import { atom } from 'recoil';

const memberInfo = atom<{ name: string; id: string }>({
  key: 'memberInfo',
  default: {
    name: localStorage.getItem('memberName') || '',
    id: localStorage.getItem('memberId') || '',
  },
});

export default memberInfo;
